// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-date-editor{display:grid;height:100%}.ag-date-editor input{min-width:0}`, "",{"version":3,"sources":["webpack://./src/agElements/editors/agDateEditor.scss"],"names":[],"mappings":"AAAA,gBAAgB,YAAY,CAAC,WAAW,CAAC,sBAAsB,WAAW","sourcesContent":[".ag-date-editor{display:grid;height:100%}.ag-date-editor input{min-width:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
